import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Glob from "../../../Globale";
import { Metodi } from "../../../ChiamaWeb";
import { ManageRedirect } from "../../helpers/Common";

const useStyles = makeStyles({
    wrapper: {
        position: "relative"
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    }
});

interface IButtonAPIProps {
    Testo: string;
    URL: string;
    Nome?: string;
    Default?: boolean;
    Attivo?: boolean;
    ParamURLLista?: { [Param: string]: string | number | boolean };
    ParamURLClasse?: { [Param: string]: string | number | boolean };
    ParamCorpo?: unknown;
    Metodo?: Metodi;
    OnClick?: (dati: unknown) => void;
    OnErrore?: (errore: Error) => void;
    OnInvio?: () => any;
    InviaFile?: boolean;
    Hidden?: boolean;
    Icona?: string;
    Alt?: string;
}

export const _ButtonAPI: React.FC<IButtonAPIProps> = props => {
    const classes = useStyles();
    const [Loading, setLoading] = useState(false);

    const CalcolaURL = (): string => {
        let URL: string = props.URL;
        if (props.ParamURLLista != undefined) {
            URL += URL.indexOf("?") > -1 ? "&" : "?";
            for (let P in props.ParamURLLista) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(props.ParamURLLista[P]) + "&";
            }
        }
        if (props.ParamURLClasse != undefined) {
            URL += URL.indexOf("?") > -1 ? "&" : "?";
            for (let P in props.ParamURLClasse) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(props.ParamURLClasse[P]) + "&";
            }
        }
        if (URL.toLowerCase().indexOf("sessione=") == -1) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?") + "sessione=" + (Glob.GetSessione() && Glob.GetSessione().Sessione);
        }
        return URL;
    };

    const OnClick = () => {
        let URL = CalcolaURL();
        if (Loading) {
            Glob.LogInfo(Glob.LogCat.API, "Già in attesa per caricamento BottoneAPI (" + props.Nome + "): " + props.URL);
        } else {
            setLoading(true);
            Glob.LogInfo(Glob.LogCat.API, "Attesa caricamento BottoneAPI (" + props.Nome + "): " + props.URL);

            var RI: RequestInit = {};
            if (props.InviaFile && props.OnInvio != undefined) {
                RI.method = "POST";
                let OnInvio = props.OnInvio();
                Glob.Log(Glob.LogCat.API, false, "OnInvio per BottoneAPI - File (" + props.Nome + "): " + props.URL, OnInvio);
                if (OnInvio == false) {
                    setLoading(false);
                    return;
                } else {
                    RI.body = OnInvio;
                }
            } else {
                RI.headers = {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                };
                if ((props.ParamCorpo != undefined || props.OnInvio != undefined) && props.Metodo == "GET") {
                    RI.method = "POST";
                } else {
                    RI.method = props.Metodo;
                }
                if (props.ParamCorpo != undefined) {
                    RI.body = JSON.stringify(props.ParamCorpo);
                    Glob.Log(Glob.LogCat.API, false, "OnInvio per BottoneAPI - ParamCorpo (" + props.Nome + "): " + props.URL, props.ParamCorpo);
                } else {
                    if (props.OnInvio != undefined) {
                        let OnInvio = props.OnInvio();
                        Glob.Log(Glob.LogCat.API, false, "OnInvio per BottoneAPI - OnInvio (" + props.Nome + "): " + props.URL, OnInvio);
                        if (OnInvio == false) {
                            setLoading(false);
                            return;
                        }
                        RI.body = JSON.stringify(OnInvio);
                    }
                }
            }

            fetch(URL, RI)
                .then(response => {
                    if (response.ok) {
                        if (response.redirected) {
                            Glob.Log(Glob.LogCat.API, true, "Richiesto redirect (" + props.Nome + "): " + response.url);
                            ManageRedirect(response.url);
                        }

                        response
                            .text()
                            .then(text => {
                                let data = JSON.parse(text, Glob.DateReviver);

                                setLoading(false);
                                Glob.Log(Glob.LogCat.API, false, "Risultato caricamento BottoneAPI (" + props.Nome + "): " + props.URL, data);
                                if (props.OnClick != undefined) {
                                    props.OnClick(data);
                                }
                            })
                            .catch(e => {
                                setLoading(false);
                                Glob.Log(Glob.LogCat.API, true, "Errore caricamento BottoneAPI (" + props.Nome + "): " + props.URL + " (JSON)", e);
                                if (props.OnErrore != undefined) {
                                    props.OnErrore(e);
                                }
                            });
                    } else {
                        setLoading(false);
                        Glob.Log(Glob.LogCat.API, true, "Errore caricamento BottoneAPI (" + props.Nome + "): " + props.URL + " (HTTP)", response);
                        if (props.OnErrore != undefined) {
                            props.OnErrore(new Error(response.statusText));
                        }
                    }
                })
                .catch(e => {
                    setLoading(false);
                    Glob.Log(Glob.LogCat.API, true, "Errore caricamento BottoneAPI (" + props.Nome + "): " + props.URL + " (Rete)", e);
                    if (props.OnErrore != undefined) {
                        props.OnErrore(e);
                    }
                });
        }
    };

    return (
        <div className={classes.wrapper}>
            <Button
                fullWidth
                onClick={e => {
                    e.preventDefault();
                    OnClick();
                }}
                variant={props.Default ? "contained" : "outlined"}
                color={props.Default ? "secondary" : "primary"}
                type={props.Default ? "submit" : "button"}
                className={clsx(props.Hidden && "hidden")}
                title={props.Alt}
                disabled={Loading || props.Attivo != undefined ? !props.Attivo : false}
                startIcon={props.Icona}
            >
                {props.Testo}
            </Button>
            {Loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
    );
};

_ButtonAPI.defaultProps = {
    Attivo: true,
    Metodo: "GET",
    Default: false,
    InviaFile: false
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/ButtonAPI.tsx